import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getSharedResourcesForOverlappingActivities';
export const getSharedResourcesForOverlappingActivities = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
